module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content-wrap"
    }
  }, [_c('div', {
    staticClass: "box box-widget widget-user-2"
  }, [_c('div', {
    staticClass: "widget-user-header",
    staticStyle: {
      "background-color": "#367fa9",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.goHome()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "80px",
      "cursor": "pointer",
      "padding-left": "1%"
    },
    attrs: {
      "src": require("../../static/img/logo-small.png"),
      "alt": "Printer Counters"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "widget-user-desc",
    staticStyle: {
      "margin-left": "5%",
      "cursor": "pointer"
    }
  }, [_vm._v("Printer Counters Monitoring")]), _vm._v(" "), _c('h5', {
    staticClass: "widget-user-desc",
    staticStyle: {
      "margin-left": "5%",
      "cursor": "pointer"
    }
  }, [_vm._v("Ver. " + _vm._s(_vm.$root.version))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "info"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "margin-bottom": "60px"
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "34px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$root.Announcement.Title))]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "color": "#58585a",
      "text-align": "center",
      "margin-left": "100px",
      "margin-right": "100px"
    }
  }, [_c('i', [_vm._v(_vm._s(_vm.$root.Announcement.Info))])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('contact'), _vm._v(" "), _c('footerBox')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "color": "#58585a",
      "text-align": "center"
    }
  }, [_c('i', [_vm._v("Please retry later !!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9bcf67a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Announcement.vue
// module id = 741
// module chunks = 0